import axios, {RawAxiosRequestHeaders} from 'axios'
import {Freelancer} from '../types'

export const httpGetAdmins = ({headers}: {headers: RawAxiosRequestHeaders}) => axios.get('/admin', {headers})

export interface HttpForceMatchOptions {
    urlParams: {
        quoteId: number
    }
    payload: {
        photographer_id: number
        ignore_photographer_market: boolean
        ignore_photographer_previous_rejection: boolean
        set_a_manual_rate: boolean
        rate: number
    }
    headers: RawAxiosRequestHeaders
}
export const httpForceMatch = ({urlParams, headers, payload}: HttpForceMatchOptions) =>
    axios.post(`/admin/quotes/${urlParams.quoteId}/navigate-forced-matches`, payload, {headers})

export interface HttpUpdateForcedMatchOptions {
    urlParams: {
        quoteId: number
        forcedMatchId: number
    }
    payload: {
        status: 'inactive'
    }
    headers: RawAxiosRequestHeaders
}
export const httpUpdateForcedMatch = ({urlParams, payload, headers}: HttpUpdateForcedMatchOptions) =>
    axios.patch(`/admin/quotes/${urlParams.quoteId}/navigate-forced-matches/${urlParams.forcedMatchId}`, payload, {
        headers
    })

export interface HttpChangePhotographerStatusOptions {
    urlParams: {
        photographerId: Freelancer['id']
    }
    payload:
        | {
              status: 'deactivated'
              deactivation_reason: string
              suspension_reason?: never
          }
        | {
              status: 'suspended'
              suspension_reason: string
              deactivation_reason?: never
          }
        | {
              status: 'active_available' | 'active_unavailable'
              deactivation_reason?: never
              suspension_reason?: never
          }
    headers: RawAxiosRequestHeaders
}

export const httpChangePhotographerStatus = ({urlParams, payload, headers}: HttpChangePhotographerStatusOptions) => {
    return axios.post(`/admin/photographers/${urlParams.photographerId}/status`, payload, {
        headers
    })
}
